import { render, staticRenderFns } from "./proportion.vue?vue&type=template&id=1b51e90d&scoped=true&"
import script from "./proportion.vue?vue&type=script&lang=js&"
export * from "./proportion.vue?vue&type=script&lang=js&"
import style0 from "./proportion.vue?vue&type=style&index=0&id=1b51e90d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51e90d",
  null
  
)

export default component.exports